module.exports = __webpack_public_path__ + "static/media/bd.c9549c3c.svg";